import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import { GREY_TEXT } from '../AnalyticsV2.styled';
import {
  Container,
  Title,
  Statistics,
  ResendStats,
  Bold,
  ArrowUpIcon,
  ArrowDownIcon,
  Row,
  Column,
  Value,
  EmptySpace,
} from '../../../Component/Analytics/Components/MessageAnalytics/Components/Card.styled';

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

// "Email only" under the title of an email-only tile under All channels.
export const EmailOnly = styled.div`
  margin-top: 4px;
  font-size: 11px;
  color: ${GREY_TEXT};
`;

const Footnote = styled.div`
  margin-top: -15px;
  font-size: 11px;
  color: ${GREY_TEXT};
`;

// Copied from isNotZero in Card.js.
const isNotZero = value =>
  value !== '0%' && value !== '0.0%' && value !== 0 && value !== null;

// The resend line, as Card.js writes it.
const ResendLine = ({ resend }) => {
  const { value, count, isComparative } = resend;
  if (!isNotZero(value)) return <>no change from resend</>;
  if (!isComparative) {
    return (
      <>
        Resend: <Bold> {value}</Bold> ({count})
      </>
    );
  }
  if (value && !String(value).startsWith('-')) {
    return (
      <>
        <ArrowUpIcon />
        <Bold>+{value}</Bold>
        from resend ({count})
      </>
    );
  }
  return (
    <>
      <ArrowDownIcon />
      <Bold>{value}</Bold>
      from resend ({count})
    </>
  );
};

// A single-version tile, laid out as the current page's Card.js.
// tile: from getTileValues or getCombinedTileValues (which adds `footnote`,
// shown under the count). isSmallValue: the message is scheduled or
// cancelled, which Card.js shows at 20px. isEmailOnly: show "Email only"
// under the title. onClick: null when not clickable. graphToggle: the
// GraphToggle element for the top right corner.
const StatCard = ({
  tile,
  Icon,
  isSmallValue,
  isEmailOnly,
  onClick,
  graphToggle,
}) => {
  const { name, tooltip, noDataText, value, count, resend, footnote } = tile;

  return (
    <Tooltip title={tooltip} placement="top">
      <Container onClick={onClick}>
        <TitleRow>
          <div>
            <Title>{name}</Title>
            {isEmailOnly && <EmailOnly>Email only</EmailOnly>}
          </div>
          {graphToggle}
        </TitleRow>
        <Column>
          <Row>
            <Icon />
            <Statistics fontSize={isSmallValue ? '20px' : '34px'}>
              {noDataText || value}
            </Statistics>
          </Row>
          {resend && (
            <ResendStats>
              <ResendLine resend={resend} />
            </ResendStats>
          )}
        </Column>
        {noDataText ? <EmptySpace /> : <Value>{count || '0'}</Value>}
        {footnote && <Footnote>{footnote}</Footnote>}
      </Container>
    </Tooltip>
  );
};

export default StatCard;
